import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=993e04d2&scoped=true"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"
import style0 from "./CardFooter.vue?vue&type=style&index=0&id=993e04d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993e04d2",
  null
  
)

export default component.exports